import { changePublisherWebsiteStatusApi } from '@api/publishers.api';
import { PublisherWebsiteStatus } from 'respona_api/generated/common_pb';
import { PublishersWebsiteDetailsType } from '@ts/publishers.types';

/**
 * RES-7362: a website goes on sale once its price and links per guest post are saved (wizard step 2,
 * "Set your price"), instead of waiting for "Continue without verification" on step 4: publishers often
 * leave the wizard before it. Verifying ownership stays optional.
 *
 * Only a DRAFT is switched, so a website the publisher paused stays paused when they edit it. A failed switch
 * resolves with the website as it was: step 4 still offers "Add site without verification".
 */
const activateDraftWebsite = (
  workspaceId: number,
  website: PublishersWebsiteDetailsType
): Promise<PublishersWebsiteDetailsType> => {
  if (website.status !== PublisherWebsiteStatus.PW_DRAFT) {
    return Promise.resolve(website);
  }

  return changePublisherWebsiteStatusApi(website.id, workspaceId, PublisherWebsiteStatus.PW_ACTIVE)
    .then(() => ({ ...website, status: PublisherWebsiteStatus.PW_ACTIVE }))
    .catch((error) => {
      console.error(error);
      return website;
    });
};

export default activateDraftWebsite;
